import logoHs from "@/assets/images/logo_hs.png";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Image } from "./Image";

export function FixedTop() {
  const [time, setTime] = useState(dayjs().format("ddd MMM DD hh:mm A"));
  const [isFullScreen, setIsFullScreen] = useState(false);

  const fullscreenchangeHandler = useCallback(() => {
    if (document.fullscreenElement) {
      setIsFullScreen(true);
    } else {
      setIsFullScreen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("fullscreenchange", fullscreenchangeHandler);

    return () => {
      document.removeEventListener("fullscreenchange", fullscreenchangeHandler);
    };
  }, [fullscreenchangeHandler]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(dayjs().format("ddd MMM DD hh:mm A"));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const makeFullscreen = () => {
    setIsFullScreen(true);
    document.documentElement.requestFullscreen();
  };

  const closeFullscreen = () => {
    setIsFullScreen(false);
    document.exitFullscreen();
  };

  return (
    <div className="fixed w-screen h-8 bg-black/10 backdrop-blur-[20px] flex items-center justify-between px-2 py-1 z-50 top-0">
      <Link to="/" className=" flex gap-3 items-center cursor-pointer">
        <Image
          width={144}
          height={72}
          alt="Holdstation"
          src={logoHs}
          className="w-12"
        />
      </Link>
      <div className="flex items-center">
        <div className="flex gap-2 items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <title>Sound</title>
            <g clipPath="url(#clip0_613_17415)">
              <path
                d="M11.0498 2.75001C11.1803 2.65671 11.3329 2.59926 11.4925 2.58339C11.652 2.56752 11.813 2.59379 11.9592 2.65957C12.1055 2.72536 12.2319 2.82836 12.3259 2.95828C12.4199 3.08821 12.4781 3.24052 12.4948 3.40001L12.4998 3.49501V16.505C12.4999 16.6654 12.4579 16.8229 12.378 16.962C12.2981 17.101 12.1831 17.2167 12.0445 17.2974C11.906 17.3781 11.7486 17.4211 11.5883 17.422C11.4279 17.4229 11.2701 17.3817 11.1307 17.3025L11.0507 17.2508L5.5665 13.3333H3.33317C2.91269 13.3335 2.5077 13.1747 2.19938 12.8888C1.89106 12.6029 1.70221 12.211 1.67067 11.7917L1.6665 11.6667V8.33334C1.66637 7.91286 1.82518 7.50787 2.11108 7.19955C2.39699 6.89123 2.78887 6.70238 3.20817 6.67084L3.33317 6.66667H5.5665L11.0498 2.75001ZM16.389 5.65251C17.0013 6.19914 17.491 6.86907 17.8261 7.61833C18.1611 8.36759 18.3339 9.17924 18.3332 10C18.3339 10.8208 18.1611 11.6324 17.8261 12.3817C17.491 13.1309 17.0013 13.8009 16.389 14.3475C16.3077 14.4217 16.2124 14.479 16.1088 14.5162C16.0052 14.5534 15.8953 14.5697 15.7853 14.5641C15.6754 14.5585 15.5676 14.5312 15.4683 14.4838C15.3689 14.4364 15.28 14.3697 15.2066 14.2877C15.1331 14.2057 15.0767 14.1099 15.0405 14.006C15.0042 13.902 14.989 13.7919 14.9956 13.682C15.0022 13.5721 15.0304 13.4646 15.0788 13.3657C15.1272 13.2668 15.1946 13.1785 15.2773 13.1058C15.715 12.7155 16.065 12.237 16.3045 11.7017C16.5439 11.1664 16.6673 10.5864 16.6665 10C16.6665 8.76667 16.1315 7.65834 15.2773 6.89417C15.1946 6.82151 15.1272 6.73318 15.0788 6.63428C15.0304 6.53539 15.0022 6.4279 14.9956 6.31801C14.989 6.20812 15.0042 6.09802 15.0405 5.99406C15.0767 5.8901 15.1331 5.79435 15.2066 5.71233C15.28 5.63031 15.3689 5.56366 15.4683 5.51621C15.5676 5.46877 15.6754 5.44148 15.7853 5.43592C15.8953 5.43035 16.0052 5.44663 16.1088 5.48381C16.2124 5.52098 16.3077 5.57832 16.389 5.65251ZM14.7223 7.51584C15.072 7.82812 15.3518 8.2108 15.5432 8.63877C15.7346 9.06674 15.8335 9.53034 15.8332 9.99917C15.8337 10.4683 15.7351 10.9322 15.5436 11.3605C15.3522 11.7888 15.0723 12.1717 14.7223 12.4842C14.5643 12.6245 14.3588 12.6996 14.1476 12.6942C13.9363 12.6887 13.7349 12.6032 13.5843 12.4549C13.4337 12.3066 13.3451 12.1067 13.3363 11.8955C13.3276 11.6843 13.3995 11.4777 13.5373 11.3175L13.6107 11.2425C13.9523 10.9358 14.1665 10.4933 14.1665 10C14.1675 9.57327 14.0039 9.16257 13.7098 8.85334L13.6107 8.75751C13.528 8.68484 13.4605 8.59651 13.4121 8.49762C13.3638 8.39873 13.3355 8.29123 13.3289 8.18134C13.3223 8.07145 13.3376 7.96135 13.3738 7.85739C13.41 7.75343 13.4665 7.65768 13.5399 7.57566C13.6133 7.49365 13.7023 7.42699 13.8016 7.37955C13.9009 7.3321 14.0087 7.30481 14.1186 7.29925C14.2286 7.29369 14.3385 7.30997 14.4422 7.34714C14.5458 7.38432 14.641 7.44165 14.7223 7.51584Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_613_17415">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="text-base text-white font-medium">Sound</p>
        </div>

        <div className="w-[1px] h-2 bg-white mx-4  hidden md:block"></div>

        <button
          type="button"
          className="p-1  hidden md:block"
          onClick={() => (isFullScreen ? closeFullscreen() : makeFullscreen())}
        >
          <div className="flex gap-2 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <title>{isFullScreen ? "Exit Fullscreen" : "Fullscreen"}</title>
              <g clipPath="url(#clip0_613_17422)">
                <path
                  d="M3.33333 12.5C3.55435 12.5 3.76631 12.5878 3.92259 12.7441C4.07887 12.9004 4.16667 13.1123 4.16667 13.3333V15.8333H6.66667C6.88768 15.8333 7.09964 15.9211 7.25592 16.0774C7.4122 16.2337 7.5 16.4457 7.5 16.6667C7.5 16.8877 7.4122 17.0996 7.25592 17.2559C7.09964 17.4122 6.88768 17.5 6.66667 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V13.3333C2.5 13.1123 2.5878 12.9004 2.74408 12.7441C2.90036 12.5878 3.11232 12.5 3.33333 12.5ZM16.6667 12.5C16.8708 12.5 17.0678 12.575 17.2203 12.7106C17.3728 12.8462 17.4703 13.0331 17.4942 13.2358L17.5 13.3333V15.8333C17.5001 16.2538 17.3413 16.6588 17.0554 16.9671C16.7695 17.2754 16.3776 17.4643 15.9583 17.4958L15.8333 17.5H13.3333C13.1209 17.4998 12.9166 17.4184 12.7622 17.2726C12.6077 17.1268 12.5148 16.9275 12.5024 16.7155C12.4899 16.5035 12.5589 16.2947 12.6952 16.1318C12.8315 15.9689 13.0249 15.8643 13.2358 15.8392L13.3333 15.8333H15.8333V13.3333C15.8333 13.1123 15.9211 12.9004 16.0774 12.7441C16.2337 12.5878 16.4457 12.5 16.6667 12.5ZM15.8333 2.5C16.2538 2.49987 16.6588 2.65867 16.9671 2.94458C17.2754 3.23049 17.4643 3.62237 17.4958 4.04167L17.5 4.16667V6.66667C17.4998 6.87907 17.4184 7.08336 17.2726 7.23781C17.1268 7.39225 16.9275 7.4852 16.7155 7.49764C16.5035 7.51009 16.2947 7.4411 16.1318 7.30478C15.9689 7.16845 15.8643 6.97508 15.8392 6.76417L15.8333 6.66667V4.16667H13.3333C13.1209 4.16643 12.9166 4.0851 12.7622 3.93929C12.6077 3.79349 12.5148 3.59421 12.5024 3.38217C12.4899 3.17014 12.5589 2.96135 12.6952 2.79847C12.8315 2.6356 13.0249 2.53092 13.2358 2.50583L13.3333 2.5H15.8333ZM6.66667 2.5C6.87907 2.50024 7.08336 2.58157 7.23781 2.72737C7.39225 2.87318 7.4852 3.07246 7.49764 3.2845C7.51009 3.49653 7.4411 3.70532 7.30478 3.86819C7.16845 4.03107 6.97508 4.13575 6.76417 4.16083L6.66667 4.16667H4.16667V6.66667C4.16643 6.87907 4.0851 7.08336 3.93929 7.23781C3.79349 7.39225 3.59421 7.4852 3.38217 7.49764C3.17014 7.51009 2.96135 7.4411 2.79847 7.30478C2.6356 7.16845 2.53092 6.97508 2.50583 6.76417L2.5 6.66667V4.16667C2.49987 3.74619 2.65867 3.34119 2.94458 3.03288C3.23049 2.72456 3.62237 2.5357 4.04167 2.50417L4.16667 2.5H6.66667Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_613_17422">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p className="text-base text-white font-medium">
              {isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
            </p>
          </div>
        </button>

        <div className="w-[1px] h-2 bg-white mx-4"></div>

        <span className="text-base text-white font-medium">{time}</span>
      </div>
    </div>
  );
}
